<script>
  import {isArray} from 'lodash'
  import PeritoService from '../../../../domain/policia-civil/perito-vistoriador/services/perito-vistoriador'
  import {REAL_BRL} from '../../../../utils/helpers/money'
  import {VMoney} from 'v-money'
  import {VueMaskDirective as mask} from 'v-mask'
  import moment from 'moment'
  import ACL from '../../../../domain/acl/tmp-acl'
  import {mapGetters} from 'vuex'
  import {cadastrarPericia, findPericia} from '../../../../domain/policia-civil/pericia/services/pericia'

export default {
    nome: 'pericia',
    props: {
      grvId: {
        required: true,
        type: Number
      },
      periciaId: {
        required: false,
        type: Number
      }
    },
    directives: {money: VMoney, mask},
    data () {
      return {
        money: REAL_BRL,
        data: {
          id: null,
          codigo: null,
          dataSolicitacao: null,
          dataPericia: null,
          valorVeiculo: null,
          observacao: null,
          roApreensaoRecuperacao: null,
          periciaRealizada: null,
          situacaoChassiOutros: null,
          situacaoChassi: [],
          situacaoMotor: [],
          situacaoMotorObservacoes: null,
          veiculoNaoIdentificado: false,
          situacaoChassiObservacoes: null,
          numeroMotor: null,
          grv: null,
          perito: null
        },
        edit: false,
        cadastroError: null,
        atualizadoSucesso: null,
        peritos: [],
        situacoesMotor: [
          {id: 1, nome: 'Com motor', checked: false},
          {id: 2, nome: 'Sem motor', checked: false},
          {id: 3, nome: 'Difícil Acesso', checked: false},
          {id: 4, nome: 'Adulterado', checked: false},
          {id: 5, nome: 'Raspado', checked: false},
          {id: 6, nome: 'Oxidado', checked: false},
          {id: 7, nome: 'Bloco Virgem', checked: false}
        ],
        situacoesChassi: [
          {id: 1, nome: 'Original', checked: false},
          {id: 2, nome: 'Adulterado', checked: false},
          {id: 3, nome: 'Remarcado', checked: false},
          {id: 4, nome: 'Oxidado', checked: false}
        ]
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      }
    },
    created () {
      this.carregarPeritos()
    },
    mounted () {
      this.start()
    },
    methods: {
      start () {
        if (this.periciaId) {
          this.edit = true
          this.$parent.loading(true)
          findPericia(this.periciaId, this.isGgv)
            .then((response) => {
              this.data = response.data
              this.data.grv = this.data.grv.id
              this.situacoesChassi.forEach(situacao => {
                situacao.checked = this.data.situacaoChassi.findIndex(item => +item === situacao.id) !== -1
              })
              this.situacoesMotor.forEach(situacao => {
                situacao.checked = this.data.situacaoMotor.findIndex(item => +item === situacao.id) !== -1
              })
              this.data.dataSolicitacao = this.data.dataSolicitacao ? moment(this.data.dataSolicitacao.date).format('L LT') : null
              this.data.dataPericia = this.data.dataPericia ? moment(this.data.dataPericia.date).format('L LT') : null

              if (this.data.perito) {
                this.data.perito = this.data.perito.id
              }
              console.log(response)
            })
            .catch((response) => {
              console.log(response)
            })
            .finally(() => {
              this.$parent.loading(false)
            })
        } else {
          this.data.grv = this.grvId
        }
      },
      submit () {
        this.cadastroError = null
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde, registrando perícia...')
        }, 1000)
        const data = JSON.parse(JSON.stringify(this.data))
        data.valorVeiculo = +data.valorVeiculo.replace(/^\D*/, '').replace(/\./g, '').replace(/,/, '.')
        data.situacaoChassi = this.situacoesChassi.filter(situacao => situacao.checked).map(situacao => situacao.id)
        data.situacaoMotor = this.situacoesMotor.filter(situacao => situacao.checked).map(situacao => situacao.id)
        cadastrarPericia(this.periciaId, data).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            // if (this.periciaId) {
            // Continua na mesma tela de edição
            // this.$nextTick(() => {
            // this.start()
            this.$emit('finishSubmit', true)
            this.atualizadoSucesso = true
            this.$el.querySelector('#sucessMsg').focus()
            // })
            // } else {
            // Redirecionar para tela de visualização da grv criada
            // this.$router.push({name: 'grv.visualizar', params: {id: response.data.id}})
            // }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      carregarPeritos () {
        PeritoService.list(1000, 1, '')
          .then(response => {
            this.peritos = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar os peritos / vistoriadores')
            console.log(error)
          })
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">

          <!--<div class="bg-warning lter b-b wrapper-md" v-if="periciaId">
            <div class="row">
              <div class="col-xs-12">
                <h1 class="font-thin h5 text-black">
                  <--<strong>GGV</strong><br>--
                  Você está visualizando a perícia cadastrada. Não é possível editá-la.
                </h1>
              </div>
            </div>
          </div>-->

          <div class="panel panel-default">
            <div class="clearfix">
              <div>
                <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">
                  <!---->
                  <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h1 class="font-thin h3">
                          Perícia
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">

                      <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                        <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
                        <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                      </div>
                      <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
                      <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
                        <div class="font-bold">{{periciaId && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
                      </div>

                      <div class="col-sm-offset-2 col-sm-10">
                        <div class="row">
                          <div class="col-xs-4">
                            <label class="i-checks m-b-none">
                              <input type="checkbox"
                                     id="periciaRealizada"
                                     tabindex="0"
                                     aria-checked="false"
                                     aria-invalid="false" v-model="data.periciaRealizada"><i></i>
                            </label>
                            <label for="periciaRealizada">Perícia Realizada</label>
                          </div>
                          <div class="col-xs-4">
                            <label class="i-checks m-b-none">
                              <input type="checkbox"
                                     id="veiculoNaoIdentificado"
                                     tabindex="0"
                                     aria-checked="false"
                                     aria-invalid="false" v-model="data.veiculoNaoIdentificado"><i></i>
                            </label>
                            <label for="veiculoNaoIdentificado">Veículo não identificado</label>
                          </div>
                        </div><!---->
                      </div>

                      <div class="form-group">
                        <label for="roApreensaoRecuperacao" class="col-sm-2 control-label">RO Apreensão / Recuperação</label>
                        <div class="col-sm-10">
                          <input id="roApreensaoRecuperacao" type="text" class="form-control" v-model="data.roApreensaoRecuperacao"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="ci" class="col-sm-2 control-label">CI</label>
                        <div class="col-sm-10">
                          <input id="ci" type="text" class="form-control" v-model="data.codigo"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dataSolicitacaoPericia" class="col-sm-2 control-label">Data Solicitação Perícia</label>
                        <div class="col-sm-10">
                          <input id="dataSolicitacaoPericia" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataSolicitacao"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dataPericia" class="col-sm-2 control-label">Data Perícia</label>
                        <div class="col-sm-10">
                          <input id="dataPericia" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataPericia"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="valorVeiculo" class="col-sm-2 control-label">Valor do Veículo</label>
                        <div class="col-sm-10">
                          <input id="valorVeiculo" type="text" class="form-control" placeholder="R$ 0,00" v-money="money" v-model="data.valorVeiculo"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Vistoriador / Perito</label>
                        <div class="col-sm-10">
                          <select class="form-control" v-model="data.perito">
                            <option :value="null" disabled selected>Selecione</option>
                            <option :value="perito.id" v-for="perito in peritos" :key="perito.id">{{perito.nome}}</option>
                          </select>
                        </div>
                      </div>

                      <!--<div class="form-group">
                        <label for="matriculaPerito" class="col-sm-2 control-label">Matrícula / RG</label>
                        <div class="col-sm-10">
                          <input id="matriculaPerito" type="text" class="form-control"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="tipoPerito" class="col-sm-2 control-label">Tipo</label>
                        <div class="col-sm-10">
                          <input id="tipoPerito" type="text" class="form-control" disabled/>
                        </div>
                      </div>-->

                      <div class="form-group">
                        <label for="observacoesPericia" class="col-sm-2 control-label">Observações</label>
                        <div class="col-sm-10">
                          <textarea id="observacoesPericia" rows="7" class="form-control" style="resize: none;" v-model="data.observacao"></textarea>
                        </div>
                      </div>

                    </div>
                  </div>

                  <!---->
                  <div class="wrapper">
                    <div class="panel-body">
                      <hr>
                      <h4>Situação do Chassi</h4>

                      <div class="col-sm-offset-2 col-sm-10" v-for="situacaoChassi in situacoesChassi">
                        <div class="row">
                          <div class="col-xs-12">
                            <label class="i-checks m-b-none">
                              <input type="checkbox"
                                     :id="`sitChassi${situacaoChassi.id}`"
                                     tabindex="0"
                                     aria-checked="false"
                                     aria-invalid="false" v-model="situacaoChassi.checked"><i></i>
                            </label>
                            <label :for="`sitChassi${situacaoChassi.id}`">{{situacaoChassi.nome}}</label>
                          </div>
                        </div><!---->
                      </div>

                      <div class="form-group">
                        <label for="outros" class="col-sm-2 control-label">Outros</label>
                        <div class="col-sm-10">
                          <input id="outros" type="text" class="form-control" v-model="data.situacaoChassiOutros"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="observacoesSituacaoChassi" class="col-sm-2 control-label">Observações</label>
                        <div class="col-sm-10">
                          <textarea id="observacoesSituacaoChassi" rows="7" class="form-control" style="resize: none;" v-model="data.situacaoChassiObservacoes"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!---->

                  <div class="wrapper">
                    <div class="panel-body">
                      <hr>
                      <h4>Situação do Motor</h4>

                      <div class="form-group">
                        <label for="numeroMotor" class="col-sm-2 control-label">Número do Motor</label>
                        <div class="col-sm-10">
                          <input id="numeroMotor" type="text" class="form-control" v-model="data.numeroMotor"/>
                        </div>
                      </div>

                      <div class="col-sm-offset-2 col-sm-10" v-for="situacaoMotor in situacoesMotor">
                        <div class="row">
                          <div class="col-xs-12">
                            <label class="i-checks m-b-none">
                              <input type="checkbox"
                                     :id="`sitMotor${situacaoMotor.id}`"
                                     tabindex="0"
                                     aria-checked="false"
                                     aria-invalid="false" v-model="situacaoMotor.checked"><i></i>
                            </label>
                            <label :for="`sitMotor${situacaoMotor.id}`">{{situacaoMotor.nome}}</label>
                          </div>
                        </div><!---->
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv" v-if="ACL.check('restrito_visitante', currentUser.id)">{{data.id ? 'Atualizar' : 'Salvar'}}</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .form-grv label {
    cursor: pointer;
  }

  .btn-colsultaGrv {
    padding-top: 7px;
    padding-bottom: 7px;
  }
</style>



// WEBPACK FOOTER //
// Pericia.vue?21c96b6a